<div class="rule-search-wrapper">
  <i class="material-icons-outlined notranslate rule-search-icon">playlist_play</i>
  <div class="rule-search-field">
    <input class="rule-search-input"
           [formControl]="searchControl"
           [matAutocomplete]="ruleAuto"
           [placeholder]="placeholder"
           (keydown.escape)="onEscape($event)"
           autocomplete="off">
    <button class="rule-search-clear"
            type="button"
            [class.has-value]="searchControl.value"
            [attr.aria-label]="searchControl.value ? 'Clear search' : null"
            (click)="searchControl.value && clear()">
      <i class="material-icons-outlined notranslate">{{searchControl.value ? 'close' : 'search'}}</i>
    </button>
  </div>
</div>

<mat-autocomplete #ruleAuto [displayWith]="displayFn" class="rule-search-panel" (optionSelected)="onSelected($event)">
  <mat-option *ngFor="let opt of filteredOptions$ | async" [value]="opt" class="rule-search-option">
    <i [class]="opt.iconClass + ' rule-option-entity-icon'"></i>
    <span class="rule-option-name"
          [matTooltip]="opt.name"
          [matTooltipShowDelay]="500"
          matTooltipPosition="right">{{opt.name}}</span>
  </mat-option>
</mat-autocomplete>
